import Vue from 'vue';
import Vuex  from 'vuex';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import VueValidator from 'vue-validator';
import moment from 'moment-timezone';
import Vue2Filters from 'vue2-filters';
import clampy from '@clampy-js/vue-clampy';
//import VueIsotope from 'vueisotope';
import auth from './services/auth';
import Cookies from './utils/cookies';

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueValidator);
Vue.use(Vuex);
Vue.use(Vue2Filters);
Vue.use(clampy);
//Vue.use(VueIsotope);

Vue.http.options.root = '/api';

// Common requirements
window.jQuery = window.$ = require('jquery');
window.Cookies = Cookies;

$.ajaxPrefilter(function( options, originalOptions, jqXHR ) { options.async = true; });

require('bootstrap-sass');
require('sweetalert');
require('fullcalendar');
require('bootstrap-fileinput/js/fileinput');
require('eonasdan-bootstrap-datetimepicker');

/**
 * Global Components Registration
 */
import Loading from './components/loading.vue';
Vue.component('loading', Loading);

import Pagination from './components/pagination.vue';
Vue.component('pagination', Pagination);

import Tip from './components/tip.vue';
Vue.component('tip', Tip);

/**
 * Third-Party Components/Directives
 */

import i18n from 'vue-i18n/vue-i18n';
import format from 'vue-format/vue-format';
import clipboard from 'vue-clipboard';

Vue.use(i18n, {
    baseUrl: '/api/locales',
    fallbackLanguage: 'en',
    timeout: 0, // To match axios/$http
    async: false,
});
Vue.use(format);
Vue.use(clipboard);

/**
 * Filters
 */
Vue.filter('moment', function(date, format){
    if (date === null) {
      return '';
    }
    if (date.date === null) {
        return moment(date).format(format);
    }
    return moment(date.date).format(format);
});

/**
 * Directives
 */
import ClickOutside from './directives/click-outside';
import FileInput from './directives/fileinput';
import Tabs from './directives/tabs';

Vue.directive('fileinput', FileInput);
Vue.directive('tabs', Tabs);
Vue.directive('click-outside', ClickOutside);

var routes = [
    {
        path: '/',
        component: function (resolve) {
            require(['./components/root.vue'], resolve);
        },
        children: [
            {
                path: '/login',
                name: 'login',
                component: function (resolve) {
                    require(['./components/login.vue'], resolve);
                },
                meta: {
                    guest: true
                }
            },
            {
                path: '/login/email',
                name: 'login-email',
                component: function (resolve) {
                    require(['./components/login.vue'], resolve);
                },
                meta: {
                    guest: true
                }
            },
            {
                path: '/recover-password',
                name: 'recover-password',
                component: function (resolve) {
                    require(['./components/recover-password.vue'], resolve);
                },
                meta: {
                    guest: true
                }
            },
            {
                path: '/reset-password',
                name: 'reset-password',
                component: function (resolve) {
                    require(['./components/reset-password.vue'], resolve);
                },
                meta: {
                    guest: true
                }
            },
            {
                path: '/dashboard',
                name: 'dashboard',
                component: function (resolve) {
                    require(['./components/dashboard.vue'], resolve);
                },
            },
            {
                path: '/content',
                name: 'content',
                component: function (resolve) {
                    require(['./components/media-center.vue'], resolve);
                },
                children: [
                    {
                        path: ':category/list',
                        name: 'category-list',
                        component: function (resolve) {
                            require(['./components/media-center/media-category-content-list.vue'], resolve);
                        },
                    },
                    {
                        path: ':category',
                        name: 'category',
                        component: function (resolve) {
                            require(['./components/media-center/media-category.vue'], resolve);
                        },
                    },
                    {
                        path: ':category/featured',
                        name: 'category-featured',
                        component: function (resolve) {
                            require(['./components/media-center/media-category-featured-list.vue'], resolve);
                        },
                    },
                ]
            },
            {
                path: '/settings',
                component: function (resolve) {
                   require(['./components/settings/settings.vue'], resolve);
                },
                children: [
                    {
                        path: '',
                        name: 'settings',
                        component: {
                            beforeRouteEnter: function() { router.push({ name: 'settings-connections' }); }
                        },
                    },
                    {
                        path: 'personal',
                        name: 'settings-personal',
                        component: function (resolve) {
                            require(['./components/settings/personal.vue'], resolve);
                        },
                    },
                    {
                        path: 'connections',
                        name: 'settings-connections',
                        component: function (resolve) {
                            require(['./components/settings/connections.vue'], resolve);
                        },
                    },
                    {
                        path: 'referral-program',
                        name: 'settings-referral',
                        component: function (resolve) {
                            require(['./components/settings/referral-program.vue'], resolve);
                        },
                    },
                ]
            },
            {
                path: '/multiverse',
                component: function (resolve) {
                    require(['./components/multiverse/main.vue'], resolve);
                },
                children: [
                    {
                        path: '',
                        name: 'multiverse',
                        component: function (resolve) {
                            require(['./components/multiverse/analytics/dashboard.vue'], resolve);
                        },
                    },
                    {
                        path: 'facebook',
                        name: 'multiverse-facebook',
                        component: function (resolve) {
                            require(['./components/multiverse/analytics/facebook.vue'], resolve);
                        },
                    },
                    {
                        path: 'twitter',
                        name: 'multiverse-twitter',
                        component: function (resolve) {
                            require(['./components/multiverse/analytics/twitter.vue'], resolve);
                        },
                    },
                    {
                        path: 'content',
                        name: 'multiverse-content',
                        component: function (resolve) {
                            require(['./components/multiverse/analytics/content.vue'], resolve);
                        },
                    },
                ]
            },
            {
                path: '/planner',
                component: function (resolve) {
                   require(['./components/content-planner/content-planner.vue'], resolve);
                },
                children: [
                    {
                        path: '',
                        name: 'content-planner',
                        component: function (resolve) {
                            require(['./components/content-planner/planner.vue'], resolve);
                        },
                    },
                    {
                        path: 'recent-posts',
                        name: 'recent-posts',
                        component: function (resolve) {
                            require(['./components/content-planner/recent-posts.vue'], resolve);
                        },
                    },
                    {
                        path: 'saved',
                        name: 'saved-posts',
                        component: function (resolve) {
                            require(['./components/content-planner/saved-posts.vue'], resolve);
                        },
                    },
                    {
                        path: 'my-content',
                        name: 'saved-content',
                        component: function (resolve) {
                            require(['./components/content-planner/saved-content.vue'], resolve);
                        },
                    },
                    {
                        path: 'my-content/folder/:folder_id',
                        name: 'saved-content-folder',
                        component: function (resolve) {
                            require(['./components/content-planner/saved-content.vue'], resolve);
                        },
                    }
                ]
            },
            {
                path: '/analytics',
                name: 'analytics',
                component: function (resolve) {
                   require(['./components/analytics/analytics.vue'], resolve);
                },
            },
            {
                path: '/tos',
                name: 'tos',
                component: function (resolve) {
                   require(['./components/legal/terms-of-service.vue'], resolve);
                },
                meta: {
                    guest: true
                }
            },
            {
                path: '/print-tos',
                name: 'print-terms-of-service',
                component: function (resolve) {
                   require(['./components/legal/print-terms-of-service.vue'], resolve);
                },
                meta: {
                    guest: true
                }
            },
            {
                path: '/privacy',
                name: 'privacy-policy',
                component: function (resolve) {
                   require(['./components/legal/privacy-policy.vue'], resolve);
                },
                meta: {
                    guest: true
                }
            },
            {
                path: '/support',
                name: 'support',
                component: function (resolve) {
                   require(['./components/support.vue'], resolve);
                }
            },
            {
                path: '/prospect-center',
                component: function (resolve) {
                   require(['./components/prospect-center-v3/prospect-center.vue'], resolve);
                },
                children: [
                    {
                        path: '',
                        name: 'prospect-center',
                        component: {
                            beforeRouteEnter: function() { router.push({ name: 'respond' }); }
                        },
                    },
                    {
                        path: 'respond',
                        name: 'respond',
                        component: function (resolve) {
                            require(['./components/prospect-center-v3/respond.vue'], resolve);
                        },
                    },
                    {
                        path: 'contacts',
                        name: 'contacts',
                        component: function (resolve) {
                            require(['./components/prospect-center-v3/contacts.vue'], resolve);
                        },
                    },
                    {
                        path: 'personal-record',
                        name: 'personal-record',
                        component: function (resolve) {
                            require(['./components/prospect-center-v3/personal-record.vue'], resolve);
                        },
                    },
                    {
                        path: 'archive',
                        name: 'prospect-center-archive',
                        component: function (resolve) {
                            require(['./components/prospect-center-v3/archive.vue'], resolve);
                        },
                    },
                    {
                        path: 'sweeps',
                        name: 'sweeps',
                        component: function (resolve) {
                            require(['./components/prospect-center-v3/sweeps.vue'], resolve);
                        },
                    }
                ]
            },
            {
                path: '/training',
                component: function (resolve) {
                   require(['./components/training/training.vue'], resolve);
                },
                children: [
                    {
                        path: '',
                        name: 'training',
                        component: {
                            beforeRouteEnter: function() { router.push({ name: 'training-dashboard' }); }
                        },
                    },
                    {
                        path: 'dashboard',
                        name: 'training-dashboard',
                        component: function (resolve) {
                            require(['./components/training/dashboard.vue'], resolve);
                        },
                    },
                    {
                        path: 'news',
                        component: function (resolve) {
                            require(['./components/training/news.vue'], resolve);
                        },
                        children: [
                            {
                                path: '',
                                name: 'training-news',
                                component: {
                                    beforeRouteEnter: function() { router.push({ name: 'news-lessons' }); }
                                },
                            },
                            {
                                path: 'items',
                                name: 'news-lessons',
                                component: function (resolve) {
                                    require(['./components/training/news-lessons.vue'], resolve);
                                },
                            },
                            {
                                path: 'item/:lessonId',
                                name: 'news-lesson',
                                component: function (resolve) {
                                    require(['./components/training/lesson.vue'], resolve);
                                },
                            },
                        ]
                    },
                    {
                        path: 'search',
                        name: 'training-search',
                        component: function (resolve) {
                            require(['./components/training/search.vue'], resolve);
                        },
                    },
                    {
                        path: 'course/:courseId',
                        component: function (resolve) {
                            require(['./components/training/course.vue'], resolve);
                        },
                        children: [
                            {
                                path: '',
                                name: 'training-course',
                                component: {
                                    beforeRouteEnter: function() { router.push({ name: 'course-lessons' }); }
                                },
                            },
                            {
                                path: 'lessons',
                                name: 'course-lessons',
                                component: function (resolve) {
                                    require(['./components/training/lessons.vue'], resolve);
                                },
                            },
                            {
                                path: 'lesson/:lessonId',
                                name: 'training-lesson',
                                component: function (resolve) {
                                    require(['./components/training/lesson.vue'], resolve);
                                },
                            },
                        ]
                    },
                ]
            },
            {
                path: '/party',
                component: function (resolve) {
                   require(['./components/party/party.vue'], resolve);
                },
                children: [
                    {
                        path: '',
                        name: 'party',
                        component: function (resolve) {
                            require(['./components/party/main.vue'], resolve);
                        },
                    },
                    {
                        path: 'create',
                        name: 'party-create',
                        component: function (resolve) {
                            require(['./components/party/edit.vue'], resolve);
                        },
                    },
                    {
                        path: 'edit/:party_id',
                        name: 'party-edit',
                        component: function (resolve) {
                            require(['./components/party/edit.vue'], resolve);
                        },
                    },
                    {
                        path: 'analysis/:party_id',
                        name: 'party-analysis',
                        component: function (resolve) {
                            require(['./components/party/analysis.vue'], resolve);
                        },
                    }
                ]
            },
            {
                path: '/admin',
                component: function (resolve) {
                   require(['./components/admin/admin-dashboard.vue'], resolve);
                },
                admin: true,
                children: [
                    {
                        path: '',
                        name: 'admin',
                        component: function (resolve) {
                            require(['./components/admin/analytics/dashboard.vue'], resolve);
                        },
                    },
                    {
                        path: 'categories',
                        name: 'categories',
                        component: function (resolve) {
                            require(['./components/admin/media-center/categories.vue'], resolve);
                        },
                    },
                    {
                        path: 'categories/companies',
                        name: 'categories-companies',
                        component: function (resolve) {
                            require(['./components/admin/media-center/categories-companies.vue'], resolve);
                        },
                    },
                    {
                        path: 'subcategories',
                        name: 'subcategories',
                        component: function (resolve) {
                            require(['./components/admin/media-center/subcategories.vue'], resolve);
                        },
                    },
                    {
                        path: 'categories/new',
                        name: 'categories-new',
                        component: function (resolve) {
                            require(['./components/admin/media-center/category-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'subcategories/new',
                        name: 'subcategories-new',
                        component: function (resolve) {
                            require(['./components/admin/media-center/subcategory-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'categories/:category',
                        name: 'categories-edit',
                        component: function (resolve) {
                            require(['./components/admin/media-center/category-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'subcategories/:category',
                        name: 'subcategories-edit',
                        component: function (resolve) {
                            require(['./components/admin/media-center/subcategory-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'categories/:category/subcategories',
                        name: 'categories-subcategories',
                        component: function (resolve) {
                            require(['./components/admin/media-center/category-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'feeds',
                        name: 'feeds',
                        component: function (resolve) {
                            require(['./components/admin/feeds/feeds.vue'], resolve);
                        },
                    },
                    {
                        path: 'feeds/new',
                        name: 'feed-new',
                        component: function (resolve) {
                            require(['./components/admin/feeds/feed-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'feeds/:feed',
                        name: 'feed-edit',
                        component: function (resolve) {
                            require(['./components/admin/feeds/feed-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'content',
                        name: 'content-list',
                        component: function (resolve) {
                            require(['./components/admin/media-center/mv-content.vue'], resolve);
                        },
                    },
                    {
                        path: 'content/recommended',
                        name: 'content-recommended',
                        component: function (resolve) {
                            require(['./components/admin/media-center/recommended-for-you.vue'], resolve);
                        },
                    },
                    {
                        path: 'content/create',
                        name: 'content-create',
                        component: function (resolve) {
                            require(['./components/admin/media-center/mv-content-create.vue'], resolve);
                        },
                    },
                    {
                        path: 'content/new',
                        name: 'content-new',
                        component: function (resolve) {
                            require(['./components/admin/media-center/mv-content-full-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'content/edit/:contentId',
                        name: 'content-edit',
                        component: function (resolve) {
                            require(['./components/admin/media-center/mv-content-full-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'content/pending/:page',
                        name: 'content-pending',
                        component: function (resolve) {
                            require(['./components/admin/media-center/pending.vue'], resolve);
                        },
                    },
                    {
                        path: 'tags',
                        name: 'tags',
                        component: function (resolve) {
                            require(['./components/admin/media-center/tags.vue'], resolve);
                        },
                    },
                    {
                        path: 'tags/new',
                        name: 'tags-new',
                        component: function (resolve) {
                            require(['./components/admin/media-center/tag-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'tags/:tag',
                        name: 'tags-edit',
                        component: function (resolve) {
                            require(['./components/admin/media-center/tag-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'reports',
                        name: 'reports',
                        component: function (resolve) {
                            require(['./components/admin/reports.vue'], resolve);
                        },
                    },
                    // User management
                    {
                        path: 'users',
                        name: 'users',
                        component: function (resolve) {
                            require(['./components/admin/user-manager/users.vue'], resolve);
                        },
                    },
                    {
                        path: 'users/new',
                        name: 'users-new',
                        component: function (resolve) {
                            require(['./components/admin/user-manager/user-form.vue'], resolve);
                        },
                    },
                    {
                        path: 'users/:user',
                        name: 'user-edit',
                        component: function (resolve) {
                            require(['./components/admin/user-manager/user-form.vue'], resolve);
                        },
                    },
                    // Supported Country management
                    {
                        path: 'countries',
                        name: 'supported-countries',
                        component: function (resolve) {
                            require(['./components/admin/country-manager/supported-countries.vue'], resolve);
                        },
                    },
                    // Annoucement Manage
                    {
                        path: 'announcements',
                        name: 'announcements',
                        component: function (resolve) {
                            require(['./components/admin/announcements/announcements.vue'], resolve);
                        },
                    },
                    // Company Manage
                    {
                        path: 'companies',
                        component: function (resolve) {
                            require(['./components/admin/companies/companies.vue'], resolve);
                        },
                        children: [
                            {
                                path: '',
                                name: 'companies',
                                component: {
                                    beforeRouteEnter: function() { router.push({ name: 'companies-list' }); }
                                },
                            },
                            {
                                path: 'list',
                                name: 'companies-list',
                                component: function (resolve) {
                                    require(['./components/admin/companies/list.vue'], resolve);
                                },
                            },
                            {
                                path: ':company',
                                name: 'companies-edit',
                                component: function (resolve) {
                                    require(['./components/admin/companies/edit.vue'], resolve);
                                },
                            }
                        ]
                    },
                    {
                        path: 'health',
                        name: 'health',
                        component: function (resolve) {
                            require(['./components/admin/health/health.vue'], resolve);
                        },
                    },
                    //Redirects
                    {
                        path: 'settings/reward-program',
                        redirect: '/settings/referral-program'
                    },
                ]
            },
            {
                path: 'notices',
                name: 'notices',
                component: function (resolve) {
                    require(['./components/notices.vue'], resolve);
                },
            }
        ],
    }, // end '/'
    // catch all redirect
    { path: '*', redirect: '/' }
];

if (auth.isAuthenticated()) {
    if (Cookies.get('login-redirect') !== undefined) {
        routes[0].redirect = Cookies.get('login-redirect');
        Cookies.expire('login-redirect');
    } else {
        routes[0].redirect = '/dashboard';
    }
} else {
    routes[0].redirect = '/login';
}

var router = new VueRouter({
    mode: 'history',
    base: '/app/',
    routes: routes,
});

/**
 * Router config
 */
router.beforeEach(function (to, from, next) {
    if(router.app.$root.disableLinks === true){
        next(false); //abort
    }

    // bounce guests from restricted areas to login page
    if ((to.meta.guest === undefined || !to.meta.guest) && !auth.isAuthenticated()) {
        Cookies.expire('login-redirect');
        if (to !== undefined && to.path !== undefined && to.path !== "") {
            Cookies.set('login-redirect', to.path, { expires: 300 });
        }

        next({ name: 'login' });
    }

    // bounce logged in users from login page to dashboard
    if ((to.name === 'login' || to.path === '') && auth.isAuthenticated()) {
        next({ name: 'dashboard' });
    }

    if(router.app.$root.$store &&
        router.app.$root.$store.state.user &&
        router.app.$root.$store.state.user.subscription &&
        router.app.$root.$store.state.user.subscription.active === false &&
        (to.name !== 'settings-connections' && to.name !== 'dashboard' && to.name !== 'login')
    ) {
        swal('Subscribe now!', 'It doesn\'t have to end this way! Update your billing settings now to continue your access to Multibrain.', 'error');
        next({ name: 'settings-connections' });
    }

    next();
});

router.afterEach(function (to, from, next) {
    if (typeof window.ga === 'function') {
        window.ga('send', 'pageview', to.path);


        window.ga(function () {
            if (window.ga.getByName('gaTupperware')) {
                window.ga('gaTupperware.send', 'pageview', to.path);
            }
        });
    }

    if (typeof window.Intercom === 'function') {
        window.Intercom('update');
    }
});

/**
 * Interceptors
 */
var requests = [];

Vue.http.interceptors.push(function(request, next) {

    var headers = request.headers;

    // store request in case we need to abort
    requests.push(request);

    if (!headers.hasOwnProperty('Authorization')) {
        headers.Authorization = 'Bearer ' + auth.getToken();
    }

    next(function(response) {
        if( ! response.ok){
            switch(response.status){
                case 0:
                    //ignore
                    break;
                case 401:
                    // cancel outstanding requests
                    for (var i = 0; i < requests.length; i++) {
                        requests.shift().abort();
                    }
                    if (auth.isAuthenticated()) {
                        eventHub.$emit('user.logout');
                    }

                    break;

                case 422:
                    if(response.data.message){
                        var msg = response.data.message;
                        var errors = response.data.errors;

                        for (var key in errors) {
                            if (errors.hasOwnProperty(key)) {
                                msg += '<br />' + errors[key];
                            }
                        }
                        let div = document.createElement('div');
                        div.innerHTML = msg;
                        swal({
                          title: 'Oops...',
                          content: div,
                          icon: "error",
                          button: router.app.$i18n.general.ok
                        });
                    }
                    break;

                case 429:
                    swal(router.app.$i18n.exceptions.app.please_wait, router.app.$i18n.exceptions.app.too_many_requests, 'error', {button: router.app.$i18n.general.ok});
                    break;

                case 402:
                    // Do Nothing on this end
                    // Payment required!
                    break;

                case 403:
                    // Forbidden. (Could be missing permission)
                    // Let the component handle this
                    break;

                case 409:
                    // Do Nothing on this end
                    // Conflict! Probably facebook page already in use by another user.
                    // Let the component handle this
                    break;

                case 404:
                    // Something was not found, let the component
                    // that did the request handle that...
                    break;

                default:
                    // Post gone. Let the component handle this
                    if(
                        response.body.status_code === 500 &&
                        response.body.message.match(/Unsupported get request\. Object with ID '.*' does not exist/)
                    ) {
                        break;
                    }

                    // Token issue. Let the component handle this
                    if(
                        response.body.status_code === 500 &&
                        typeof response.body.code !== 'undefined' &&
                        response.body.code === 190
                    ) {
                        break;
                    }

                    // Something went wrong...
                    if (response.body.message && response.body.message.indexOf('appsecret_proof')>-1) {
                        let div = document.createElement('div');
                        div.innerHTML = router.app.$i18n.exceptions.app.wrong_app;
                        swal({
                            title: router.app.$i18n.general.oops,
                            content: div,
                            icon: 'error',
                            button: router.app.$i18n.general.ok
                        });
                    } else {
                        let div = document.createElement('div');
                        div.innerHTML = router.app.$i18n.exceptions.app.something_went_wrong;
                        swal({
                            title: router.app.$i18n.general.oops,
                            content: div,
                            icon: 'error',
                            button: router.app.$i18n.general.ok
                        });
                    }
                    break;
            }
        }

        return response;
    });
});


// This is the event hub we'll use in every
// component to communicate between them.
window.eventHub = new Vue();

import App from './app.vue';

var store = require('./stores/store');

// Global company group checks
Vue.mixin({
    computed: {
        isAvon: function() {
            if (store.state.user.company.data.id !== undefined) {
                if (store.state.user.company.data.id == 12) {
                    return true;
                }
            }
            return false;
        },
        isAvonPR: function() {
            if (store.state.user.company.data.id !== undefined) {
                if (store.state.user.company.data.id == 52) {
                    return true;
                }
            }
            return false;
        },
        isAvonDomain: function() {
            return (window.location.hostname == 'social.youravon.com' || window.location.hostname == 'social-qaf.youravon.com');
        },
        isTupperware: function() {
            if (
                store.state.user.company.data.name !== undefined &&
                    (
                        store.state.user.company.data.name.match(/^TupSocial/i) ||
                        store.state.user.company.data.name.match(/^TuppSocial/i) ||
                        store.state.user.company.data.name.match(/^Tupperware/i)
                    )
            ) {
                return true;
            }

            return false;
        },
        isNutrimetics: function() {
            if (
                store.state.user.company.data.name !== undefined &&
                    (
                        store.state.user.company.data.name.match(/^Nutrimetics/i)
                    )
            ) {
                return true;
            }
        
            return false;
        },
        isRodan: function() {
            if (
                store.state.user.company.data.name !== undefined &&
                    (
                        store.state.user.company.data.name.match(/^Rodan/i) ||
                        store.state.user.company.data.name.match(/^R\+F/i)
                    )
            ) {
                return true;
            }

            return false;
        },
        isAuxano: function() {
            if (
                store.state.user.company.data.name !== undefined &&
                    (
                        store.state.user.company.data.name.match(/^Auxano/i)
                    )
            ) {
                return true;
            }
        
            return false;
        },
    }
});

// URL API Polyfill Test (Modernizr)
// babel-polyfill doesn't catch non-ECMA stuff
let url, hasUrl;
try {
  url = new URL('https://multibrain.me/');
  hasUrl = url.href === 'https://multibrain.me/';
} catch (e) {
  hasUrl = false;
}
if(!hasUrl) {
    require('./polyfills/url.js');
}

const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js